
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Table,
} from "reactstrap";
import { fetchLanguages } from "slices/languageSlice";
import { languageSelector } from "slices/languageSlice";

import Api from "services/api"
import AddLanguage from "components/language/AddLanguage";
import ImportLanguage from "components/language/ImportLanguage";
import { removeLanguage } from "slices/languageSlice";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { SortButtons } from "components/common/SortButtons";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/languageSlice";
import { removeMultipleLanguages } from "slices/languageSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";

const apiService = new Api();

function LanguageList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { language: languages, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(languageSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [importModal, setImportModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [exporting, setExporting] = React.useState(false);
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });



  React.useEffect(() => {
    dispatch(fetchLanguages())
  }, [])

  const handleAddLanguagePopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchLanguages())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleLanguages({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(languages?.map((language) => language.id.toString()))


  }

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchLanguages(page));
  }, [])

  const handleClose = () => {
    // refAddutton.current.click(); setAddForm({ show: false })
    setAddForm({ show: false , item: {}});
  };

  const handleOpenImportModal = () => {
    setImportModal(true);
  };

  const handleCloseImportModal = () => {
    setImportModal(false);
  };

  const handleSelect = (value) => {
    setSelectedValue(value)

  }


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {

    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchLanguages(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th className="col-2">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Languages') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th className="col-5">

          <TableHeaderItem
            title="Language Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-3">
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status Languages') &&
          <th className="col-3">Status</th>
        }
        {checkPermission('Edit Languages') &&
          <th className="col-3">Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      languages?.map((language, index) => (
        <LanguageItem language={language} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddLanguagePopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [languages, selectedItems]);

  //#endregion

  const handleDownloadCsv = async () => {
    setExporting(true);
    try {
      const params = {
        sortBy: sortConfig.sortBy,
        sortDirection: sortConfig.sortDirection,
        search: searchTerm,
        pageLength,
      };
      const response = await Api.exportLanguagesCsv(params);
      if (response?.status >= 200 && response?.status < 300) {
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const fileName = response.headers['content-disposition']?.split('filename=')[1]?.replace(/"/g, '') || `languages_${new Date().toISOString().slice(0,10)}.csv`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        const message = response?.data?.message || 'Export failed';
        toast.error(message, { className: 'errorToast' });
      }
    } catch (error) {
      toast.error('Export failed. Please try again.', { className: 'errorToast' });
    }
    setExporting(false);
  }

  return (
    <ListLayout
      heading="Language"
      time={true}
      title=""
      buttonTitle="Add Language"
      disableBootstrap={true}
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      addButtonDisabled={!checkPermission('Create Languages')}
      fetchList={fetchLanguages}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddLanguage item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status Languages')} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddLanguagePopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader || exporting}
      sortConfig={sortConfig}
      noOfItems={total}
      searchPlaceholder="Search Language ..."
      defaultPageLength={pageLength}
      downloadCsv={true}
      onDownloadCsvClick={handleDownloadCsv}
      importBtnTitle= "Import Language"
      importCsv={true}
      onImportClick={handleOpenImportModal}
    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
      <ImportLanguage show={importModal} onClose={handleCloseImportModal} callback={() => dispatch(fetchLanguages(1))} />
    </ListLayout>
  )

}


const LanguageItem = ({
  language, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(language?.status == "active" ? 1 : 0 || 0);

  React.useEffect(() => {
    setStatus(language?.status == "active" ? 1 : 0 || 0)

  }, [language])
  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Languages') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={language.id} checked={selectedItems.includes(language.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {language.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {convertTimeToUTC(language.created_at)}
      </td>
      {checkPermission('Status Languages') &&
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <CustomSwitch handleChange={(status) => handleStatusChange(language?.id, status)} checked={status == 1 ? true : false} />
          </div>
        </td>
      }
      {checkPermission('Edit Languages') &&
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <button className="table_edit" onClick={() => handleAddPopUp({ ...language, status })}>Edit</button>
          </div>
        </td>
      }
    </tr>
  )
}


export default LanguageList;
